import React from 'react'
import PropTypes from 'prop-types'

const CleverLogo = ({
  color,
  height,
  width,
}) => {
  return (
    <span className='logo'>
      <svg viewBox='0 0 460 460' height={height} width={width} xmlns='http://www.w3.org/2000/svg'>
        <defs>
          <mask id={`mask-${color}`}>
            <g>
              <path
                d='M 399.75799560546875 100.25700378417969 L 298.83599853515625 201.1790008544922 L 299.364013671875 299.77801513671875 L 399.6839904785156 400.0979919433594 L 255.86500549316406 450.59100341796875 L 52.39099884033203 398.5989990234375 L 54.36800003051758 98.95800018310547 L 253.52999877929688 35.64899826049805 L 252.38699340820312 35.566001892089844 Z'
                style={{
                  fill: '#ffffff',
                }}
              />
            </g>
          </mask>
        </defs>
        <path d='M 437.716 251.407 C 437.716 234.118 435.377 217.638 431.048 202.172 C 426.72 186.705 420.404 172.252 412.449 159.014 C 404.494 145.776 394.902 133.754 384.022 123.151 C 373.144 112.548 360.977 103.362 347.876 95.798 C 334.775 88.234 320.738 82.291 306.115 78.171 C 291.493 74.051 276.285 71.755 260.843 71.484 C 245.401 71.215 229.726 72.971 214.168 76.955 C 198.609 80.94 183.167 87.154 168.194 95.799 C 154.295 103.824 141.731 113.548 130.703 124.627 C 119.674 135.704 110.182 148.134 102.427 161.566 C 94.671 174.999 88.654 189.435 84.574 204.525 C 80.495 219.614 78.355 235.359 78.355 251.407 C 78.355 268.697 80.692 285.179 85.018 300.649 C 89.344 316.121 95.658 330.579 103.611 343.819 C 111.564 357.06 121.155 369.083 132.036 379.684 C 142.917 390.285 155.085 399.463 168.195 407.014 C 181.289 414.592 195.323 420.541 209.943 424.663 C 224.564 428.785 239.773 431.08 255.216 431.346 C 270.66 431.614 286.338 429.853 301.899 425.863 C 317.459 421.875 332.903 415.658 347.877 407.013 C 361.775 398.989 374.34 389.264 385.368 378.186 C 396.397 367.109 405.889 354.679 413.645 341.246 C 421.4 327.814 427.417 313.378 431.496 298.288 C 435.575 283.199 437.716 267.455 437.716 251.407 Z M 365.843 251.407 C 365.843 261.781 364.438 271.665 361.839 280.94 C 359.239 290.216 355.447 298.883 350.672 306.822 C 345.897 314.762 340.141 321.973 333.614 328.337 C 327.088 334.702 319.793 340.218 311.939 344.77 C 304.071 349.296 295.645 352.856 286.871 355.326 C 278.097 357.796 268.973 359.176 259.711 359.341 C 250.449 359.506 241.047 358.458 231.714 356.071 C 222.381 353.685 213.118 349.959 204.134 344.772 C 195.794 339.957 188.256 334.122 181.639 327.475 C 175.021 320.828 169.325 313.37 164.672 305.311 C 160.018 297.25 156.408 288.589 153.959 279.535 C 151.512 270.482 150.227 261.035 150.227 251.407 C 150.227 241.032 151.632 231.148 154.232 221.874 C 156.832 212.597 160.624 203.93 165.399 195.991 C 170.173 188.052 175.93 180.84 182.456 174.476 C 188.982 168.111 196.278 162.594 204.131 158.042 C 211.999 153.516 220.426 149.957 229.2 147.487 C 237.974 145.018 247.096 143.638 256.36 143.472 C 265.622 143.307 275.024 144.355 284.358 146.742 C 293.689 149.128 302.953 152.854 311.937 158.04 C 320.276 162.856 327.815 168.691 334.432 175.339 C 341.051 181.985 346.746 189.443 351.399 197.503 C 356.052 205.563 359.664 214.224 362.112 223.279 C 364.559 232.331 365.843 241.778 365.843 251.407 Z'
          style={{
            mask: `url(#mask-${color})`,
            fill: color,
          }}
        />
      </svg>
    </span>
  )
}

CleverLogo.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
}

CleverLogo.defaultProps = {
  color: '#000000',
  height: 100,
  width: 100,
}

export default CleverLogo
